import React from 'react';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    num: 'TOMO 1',
    title: 'Escuelita — Semanas 1 a 26',
    desc: 'La primera temporada de hockey. Juegos, técnica base y amor por el deporte desde el día 1.'
  }, {
    num: 'TOMO 2',
    title: 'Escuelita — Semanas 27 a 52',
    desc: 'Cierre del año con progresión clara. Evaluación y muestra de fin de año incluidas.'
  }, {
    num: 'TOMO 3',
    title: '10ma División — Semanas 1 a 26',
    desc: 'Técnica individual y primeros sistemas colectivos. Push, recepción y corner básico.'
  }, {
    num: 'TOMO 4',
    title: '10ma División — Semanas 27 a 52',
    desc: 'Consolidación técnica y cierre de temporada con evaluaciones y campeonato simulado.'
  }, {
    num: 'TOMO 5',
    title: '9na División — Semanas 1 a 26',
    desc: 'Técnica de competencia. Sistemas de juego y primeros corners cortos reales.'
  }, {
    num: 'TOMO 6',
    title: '9na División — Semanas 27 a 52',
    desc: 'Consolidación táctica y preparación para campeonato. Presión y transiciones.'
  }, {
    num: 'TOMO 7',
    title: '8va División — Semanas 1 a 26',
    desc: 'Sistemas de juego completos. Defensa organizada y ataque estructurado por bandas.'
  }, {
    num: 'TOMO 8',
    title: '8va División — Semanas 27 a 52',
    desc: 'Alto rendimiento formativo. CC de competencia y gestión táctica de partido.'
  }, {
    num: 'TOMO 9',
    title: '7ma División — Semanas 1 a 26',
    desc: 'Táctica avanzada. Pressing, transiciones y juego aéreo integrado.'
  }, {
    num: 'TOMO 10',
    title: '7ma División — Semanas 27 a 52',
    desc: 'Consolidación y preparación para campeonato. Partido oficial simulado.'
  }, {
    num: 'TOMO 11',
    title: '6ta División — Semanas 1 a 26',
    desc: 'Alto rendimiento. Sistemas de élite y análisis táctico del rival.'
  }, {
    num: 'TOMO 12',
    title: '6ta División — Semanas 27 a 52',
    desc: 'Campeonato completo. Gestión de partido y protocolos de semifinal y final.'
  }, {
    num: 'TOMO 13',
    title: '5ta División — Semanas 1 a 26',
    desc: 'Pre-élite. Sistemas olímpicos adaptados. Preparación física integrada.'
  }, {
    num: 'TOMO 14',
    title: '5ta División — Semanas 27 a 52',
    desc: 'Consolidación de sistemas y preparación mental para campeonatos de alto nivel.'
  }, {
    num: 'TOMO 15',
    title: 'Mayores — Semanas 1 a 26',
    desc: 'El cambio de paradigma. Identidad de juego, sistema propio y gestión de plantel.'
  }, {
    num: 'TOMO 16',
    title: 'Mayores — Semanas 27 a 52',
    desc: 'Campeonato, dominio táctico completo y legado del sistema para la temporada siguiente.'
  }];
  return <section className="bg-[#F9F9F9] py-20 px-4" data-id="element-311">
      <div className="max-w-6xl mx-auto" data-id="element-312">
        <div className="text-center mb-16" data-id="element-313">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-[#0284C7] mb-4 uppercase tracking-wide" data-id="element-314">
            Los 16 Tomos Completos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 italic" data-id="element-315">
            Ejercicios graficados · Por categoría y nivel · Listo para usar
            mañana
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-316">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 4 * 0.1
        }} className="bg-white border-2 border-[#0284C7]/20 rounded-xl p-6 hover:border-[#0284C7] transition-colors shadow-sm" data-id="element-317">
              <div className="inline-block bg-[#F97316] text-white font-bold px-3 py-1 rounded mb-4 text-sm uppercase tracking-wider" data-id="element-318">
                {tomo.num}
              </div>
              <h3 className="text-xl font-bold text-[#0284C7] mb-3" data-id="element-319">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-320">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-16 text-center" data-id="element-321">
          <div className="flex items-center gap-2 text-[#0284C7] font-bold text-lg bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-322">
            <span data-id="element-323">✏️</span> Ejercicios graficados en cada tomo
          </div>
          <div className="flex items-center gap-2 text-[#0284C7] font-bold text-lg bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-324">
            <span data-id="element-325">⚡</span> Sistema "Abrí y Entrená"
          </div>
          <div className="flex items-center gap-2 text-[#0284C7] font-bold text-lg bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-326">
            <span data-id="element-327">📋</span> Fichas listas para imprimir
          </div>
          <div className="flex items-center gap-2 text-[#0284C7] font-bold text-lg bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-328">
            <span data-id="element-329">🇦🇷</span> Contenido 100% adaptado a Argentina
          </div>
        </div>

        {/* EXTRA PERSUASIVE CTA BUTTON (Requested Addition A) */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-330">
          <a href="#precio" className="inline-block bg-[#F97316] hover:bg-[#EA580C] text-white font-bold text-xl md:text-2xl px-10 py-6 rounded-xl shadow-[0_0_30px_rgba(249,115,22,0.35)] transition-all hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-331">
            🔥 Quiero todo esto en mi celular en 5 minutos →
          </a>
        </motion.div>
      </div>
    </section>;
}